import { IDME_VERIFICATION_CLOSE_URL_PATH } from './idme.constants';

export const getIsIdmeVerificationCloseUrl = (url: string) => {
  return url.includes(IDME_VERIFICATION_CLOSE_URL_PATH);
};
